import { Spinner } from '@/components/Loader/Spinner';
import { Text, View } from "@/components/Theme";
import colors from '@/constants/Colors';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { Modal, StyleSheet } from 'react-native';

export const OverlayLoader = memo(({text, description, wrapperStyle, visible = false, force = false}) => (
    <Modal visible={visible} transparent={true} animationType={force ? 'none' : "fade"}>
        
        <View style={[styles.modalBackground, wrapperStyle]}>

            <Spinner 
                bold
                size={60}
            />
            
            {typeof text === 'string' && 
                <>
                    <View h={15} />
                    <Text variant={'h1'} id={text} />
                </>
            }
            
            {typeof description === 'string' && 
                <>
                    <View h={10} />
                    <Text variant={'center'} id={description} />
                </>
            }
        </View>
        
    </Modal>
), isEqual);
 
const styles = StyleSheet.create({
    logo: {
        marginBottom: 15,  
        width: 100, 
    },
    modalBackground: {
        ...StyleSheet.absoluteFill,
        flex: 1,
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#FFFFFF',
    },
    loadingText : {
        color: colors.muted[700],
        marginTop: 15,
        fontSize: 15,
    }
});